
import { RevContainer } from '@backmarket/design-system'

export default {
  components: { RevContainer },
  props: {
    defaultWidthClass: {
      type: String,
      default: '',
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
  },
}
